import { produce, Draft } from 'immer'

type State = {
  bookingDetailsModal: boolean
  supplementsListModal: boolean
  cancelBookingModal: boolean
  updateBookingModal: boolean
  addSupplementModal: boolean
  successSelfCheckinModal: boolean
  preCheckInModal: boolean
  preCheckInConfirmModal: boolean
  handleBookingFolderInvoices: boolean
}

const modal = {
  state: {
    bookingDetailsModal: false,
    supplementsListModal: false,
    cancelBookingModal: false,
    updateBookingModal: false,
    addSupplementModal: false,
    successSelfCheckinModal: false,
    preCheckInModal: false,
    preCheckInConfirmModal: false,
    handleBookingFolderInvoices: false
  } as State,
  reducers: {
    handleModal: produce((draft: Draft<State>, payload: Partial<State>) => {
      Object.assign(draft, payload)
    })
  },
}

export default modal